export enum MajorFooter{ 
    InquiryId = "major-customerservice@major-pharm.com",
    InquiryNumber = "800.616.2471",
    SupportId = "support@major-pharm.com ",
    SupportNumber = "800.875.0123 Option 5",
    WeekWorkingTime = 'Monday - Friday 8:00 a.m.- 5:00 p.m. EST',
    WeekendWorkingTime = '',
    Copyright = 'Major Rugby, Major Pharmaceuticals, Rugby Laboratories. All Rights Reserved.',
    SiteName = 'www.major-rugby.com',
    Address1 = '341 Mason Road,',
    Address2 = 'La Vergne, TN 37086',
    backOrderMsg = 'Items on back order will ship as product becomes available per Major/Rugby policies. The provided payment method will be charged for back ordered items upon fulfillment.'
};